import { AlarmsView } from "./AlarmsView";
export default AlarmsView;
